import HTTP_METHODS from "src/general/constants/http/httpMethods";
import {
	UserDeleteRequest as Req,
	UserDeleteResponse as Res,
} from "src/business.InterfaceLayer/store/entities/user.entity/redux/api/types/DELETE";
import { createBaseQueryDefinition } from "src/business.InterfaceLayer/store/services/utils.service/ResponseTransforms";
import MAIN_PATHS from "src/business.InterfaceLayer/store/mainPaths";
import { ApiQueryBuilder } from "src/business.InterfaceLayer/store/types/ApiQueryBuilder.type";
import { UserFromDtoDelete as Dto } from "src/business.InterfaceLayer/store/entities/user.entity/services/dto/from.dto";
import { Nullable } from "../../../../../types/Nullable.type";
import USER_PATHS from "../../paths";
import { USER_FIELDS } from "../../fields";

const deleteRequestBaseDefinition = createBaseQueryDefinition(
	HTTP_METHODS.DELETE,
	MAIN_PATHS.CORE
);

const userApiDeleteQueries = (build: ApiQueryBuilder) => ({
	deleteUserDelete: build.mutation<Nullable<Res.UserDelete>, Req.UserDelete>({
		query: (body) => ({
			...deleteRequestBaseDefinition({
				path: `${USER_PATHS.USER_DELETE}/${body[USER_FIELDS.ID]}`,
			}),
		}),
		transformResponse: Dto.userDelete,
		invalidatesTags: [`${MAIN_PATHS.USER}TAG_COUNT`, `${MAIN_PATHS.USER}TAG`],
	}),
});

export default userApiDeleteQueries;
